import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import * as types from '@reserve/store/types'
import * as eventTypes from '@reserve/store/event-types'
import { createEventBus } from '@/modules/@appbase/util'

import ViewHeader from '@reserve/components/ViewHeader.vue'
import RightPane from '@reserve/components/RightPane.vue'
import ListView from '@reserve/components/ListView/ListView.vue'
import { LoadingBar } from '@appbase/components/loading'
import SideMenu from '@reserve/components/SideMenu/SideMenu.vue'


@Component({
    components: {
        ViewHeader,
        RightPane,
        ListView,
        LoadingBar,
        SideMenu
    },

    computed: mapGetters({
        isLoading: types.CALENDAR_LOADING,
        listViewOpen: types.MAIN_LISTVIEW_OPEN
    }),

    methods: mapActions({
        loadEvents: types.CALENDAR_EVENTLIST_LOAD
    })
})
export default class CalendarMaster  extends Vue {
    loadEvents!: () => Promise<any[]>;

    isLoading!: boolean;
    listViewOpen!: boolean;

    created() {
        createEventBus(window, eventTypes.EVENT_RESOURCE_EVENTLOAD, this.handleEventLoad)
    }

    handleEventLoad() {
        this.loadEvents();
    }
}